export default __webpack_public_path__ + "static/media/DSC_0583.c9476c58.jpg";